import {onBeforeUnmount, onMounted} from 'vue';
import type {MicroFrontendRootEventsMapper, MicroFrontendsWithEvents, OnMFEvent} from '@malt/nuxt-micro-frontend-types';

export function useMFEvent<T extends MicroFrontendsWithEvents, TArgs extends Record<string, any[]> = MicroFrontendRootEventsMapper[T]>(
    app: T,
    onMFEvent?: OnMFEvent<T>,
) {
    onMounted(() => {
        if (onMFEvent) {
            window.addEventListener(`${app}:mf:event`, onMFEvent);
        }
    });

    onBeforeUnmount(() => {
        if (onMFEvent) {
            window.removeEventListener(`${app}:mf:event`, onMFEvent);
        }
    });

    function dispatchMFEvent<TEvent extends keyof TArgs>(name: TEvent, ...args: TArgs[TEvent]) {
        const mfEvent = new CustomEvent(`${app}:mf:event`, {
            detail: {
                name,
                args,
            },
        });
        window.dispatchEvent(mfEvent);
    }

    return {dispatchMFEvent};
}
